import { Controller } from "@hotwired/stimulus"

export class DesignPaletteController extends Controller {
    static targets = ["swatch"]

    swatchTargetConnected(swatch) {
        const output = swatch.closest("[data-design-swatch-card]")?.querySelector("[data-palette-values]")
        if (!output) return
        const styles = getComputedStyle(swatch)
        const background = this.background(swatch)
        output.textContent = `Background: ${this.color(background)} · Text: ${this.color(styles.color)}`
    }

    background(swatch) {
        for (let element = swatch; element; element = element.parentElement) {
            const value = getComputedStyle(element).backgroundColor
            if (value !== "transparent" && value !== "rgba(0, 0, 0, 0)") return value
        }
        return "transparent"
    }

    color(value) {
        const match = value.match(/^rgb\((\d+), (\d+), (\d+)\)$/)
        return match ? `#${match.slice(1).map(channel => Number(channel).toString(16).padStart(2, "0")).join("")}` : value
    }
}
